import { historyStatusLabel, type HistoryStatus } from './historyLabels';

type IncidentStatusTagProps = {
  status: HistoryStatus;
};

const CLOSE_TONES: Record<Exclude<HistoryStatus, 'active' | 'monitoring' | 'closed'>, string> = {
  checked_by_prerender: 'recovered',
  closed_by_cs: 'closed',
  account_not_paying: 'closed',
};

const toneOf = (status: HistoryStatus): string =>
  status === 'active' || status === 'monitoring' || status === 'closed' ? status : CLOSE_TONES[status];

function IncidentStatusTag({ status }: IncidentStatusTagProps) {
  return <span className={`diagnostics-status diagnostics-status-${toneOf(status)}`}>{historyStatusLabel(status)}</span>;
}

export default IncidentStatusTag;
